/*
* 分组
* */

import {get, post, postJson, put} from '../axios'

const RESOURCE_BASE_PATH = '/shopBuyer'


//  获取会员分组POST /memberListController/getMemberList
export const getShopBuyerGroup = p => postJson(`${RESOURCE_BASE_PATH}/getShopBuyerGroup`, p);
//获取会员列表
export const getMemberList = p =>postJson(`${RESOURCE_BASE_PATH}/page`,p);
//添加会员
export const addMemberUser = p =>postJson(`${RESOURCE_BASE_PATH}/addMemberList`,p);
//会员详细信息
export const getMemberDetail = (form) =>post(`${RESOURCE_BASE_PATH}/getMemberInfo`,form);
//编辑保存会员信息
export const saveMemberDetail = (form) =>postJson(`/memberListController/updateMemberInfo`,form);
//检查会员等级是否初始化

export const judgeShopBuyerGrade = (form) =>postJson(`/shopGradeController/judgeShopBuyerGrade`,form);

// 批量打标签
export const batchInsertLabel = p =>put(`${RESOURCE_BASE_PATH}/batchAddLabel`,p);

// 根据条件打标签
export const updateLabelByCondition = (form) =>postJson(`${RESOURCE_BASE_PATH}/updateLabelByCondition`,form);

// 按查询结果打标签
export const batchAddLabelByQuery = p => put(`${RESOURCE_BASE_PATH}/batchAddLabelByQuery`, p);

// 根据查询条件取公共标签
export const getCommonLabel = (form) =>postJson(`${RESOURCE_BASE_PATH}/getCommonLabel`,form);
// 导出会员列表
export const exportMemberList = (form) =>postJson(`${RESOURCE_BASE_PATH}/exportMemberList`,form);